module.exports = __webpack_public_path__ + "img/team.50715064.jpg";